import React from 'react'
import { ProfileEdit } from '..'
import { IonLoading } from '@ionic/react'
import { useGetMe } from '../../../modules/me'

export const PageProfileEdit = () => {
  const { user } = useGetMe()
  return user ? <ProfileEdit user={user} /> : <IonLoading isOpen={true} />
}
